import { render, staticRenderFns } from "./filelist-table.vue?vue&type=template&id=66289a8e&scoped=true"
import script from "./filelist-table.vue?vue&type=script&lang=js"
export * from "./filelist-table.vue?vue&type=script&lang=js"
import style0 from "./filelist-table.vue?vue&type=style&index=0&id=66289a8e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66289a8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66289a8e')) {
      api.createRecord('66289a8e', component.options)
    } else {
      api.reload('66289a8e', component.options)
    }
    module.hot.accept("./filelist-table.vue?vue&type=template&id=66289a8e&scoped=true", function () {
      api.rerender('66289a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/filelist-table.vue"
export default component.exports